import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';

import { InputsProps } from './types';
import Prepayment from './components/Prepayment';
import Period from './components/Period';

function Inputs({ creditType, price }: InputsProps) {
  return (
    <Component>
      <Prepayment creditType={creditType} price={price} />
      <Period creditType={creditType} />
    </Component>
  );
}

export default Inputs;

const Component = styled.div`
  display: flex;
  margin-top: 10px;

  ${media.tablet(css`
    flex-direction: column;
    max-width: 500px;
    margin: 20px auto 0;
  `)}

  ${media.mobile(css`
    max-width: none;
  `)}
`;
